import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AdminConfigService } from '../admin.config';
import { AnalyticsReportRequest } from '../models/analytics-reports/analyticsReportRequest.model';
import { Blocked } from '../models/analytics-reports/blocked.model';
import { GoodsKPIReport } from '../models/analytics-reports/goods.model';
import { Sessions } from '../models/analytics-reports/session.model';
import { Users } from '../models/analytics-reports/users.model';
import { Views } from '../models/analytics-reports/views.model';

export type reportResponse = Blocked | GoodsKPIReport | Users[] | Views | Sessions;
@Injectable({ providedIn: 'root' })
export class AdminReportService {
    private readonly server = '';
    private readonly microserviceName = 'analytics/purchasingreport';
    private readonly route = '/';

    /**
     *
     * @param http
     * @param config
     */
    constructor(
        private readonly http: HttpClient,
        @Inject(AdminConfigService) private readonly config,
    ) {
        this.server = config.apiGateway;
    }

    getReport(requestParams: { payload: AnalyticsReportRequest }) {
        const url =
            // tslint:disable-next-line: max-line-length
            `${this.server}${this.microserviceName}${this.route}${requestParams.payload.kpi}${this.route}${requestParams.payload.timePeriod}${this.route}${requestParams.payload.date}${this.route}${requestParams.payload.isCouponOrders}`;
        return this.http.get<reportResponse>(url);
    }
}
